<template>
  <transition-deploy>
    <component
      :is="component"
      :class="className"
      v-if="display">
      <div class="banner__container">
        <div class="banner__inner">
          <div
            class="banner__content"
            v-html="content" />
          <button
            class="banner__close"
            @click="doClose">
            <svg
              class="banner__close-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 12 12"
              width="12"
              height="12">
              <polygon points="6,7.1 1.1,12 0,10.9 4.9,6 0,1.1 1.1,0  6,4.9 10.9,0 12,1.1 7.1,6 12,10.9 10.9,12 " />
            </svg>
          </button>
        </div>
      </div>
    </component>
  </transition-deploy>
</template>

<script>
import { trackEvent } from "@/services/tracking";
import bemBlockMofifiers from "@/utils/bem-block-modifiers";
import transitionDeploy from "@/shared/transition-deploy";
import cookie from "@/utils/cookie";
import WaveBanner from "@/shared/wave-banner";

export default {
  name: "Banner",
  components: {
    transitionDeploy,
    WaveBanner
  },
  props: {
    id: { type: String, required: true },
    type: { type: String, default: "notification" },
    content: { type: String, required: true },
    show: { type: Boolean, default: false },
    eventCategory: { type: String, default: "body-20190710-banner" },
    cookie: { type: [String, Number], default: 0 },
    modifiers: { type: Array, default: () => [] }
  },
  data() {
    return { display: false };
  },
  computed: {
    className() {
      const modifiers = this.modifiers.concat([this.type, this.id]);
      return bemBlockMofifiers("banner", modifiers);
    },
    isSale() {
      return this.modifiers.indexOf("sale") >= 0;
    },
    component() {
      return this.isSale ? WaveBanner : "div";
    },
    cookieName() {
      return `banner-${this.id}`;
    },
    isCookieSaved() {
      return cookie(this.cookieName);
    }
  },
  watch: {
    show(value) {
      value ? this.doOpen() : this.doClose();
    }
  },
  mounted() {
    if (this.show) {
      this.doOpen();
    }
  },
  methods: {
    doOpen() {
      if (this.isCookieSaved) {
        return;
      }
      this.display = true;
      this.$emit("open");
      this.track("1-open");
    },
    doClose() {
      this.display = false;
      this.$emit("close");
      this.track("1-close");

      if (this.cookie) {
        cookie(this.cookieName, true, this.cookie);
      }
    },
    track(action) {
      trackEvent(this.eventCategory, action, this.id);
    }
  }
};
</script>

<style lang="scss">
[data-banner] {
  display: none;
}

.banner {
  @include font-family(sans-serif);
  @include font-style(p, $color: $white);

  position: relative;
  z-index: $zindex-banner;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  /* stylelint-disable-next-line unit-blacklist */
  padding: rem(11px) 0 rem(13px);

  &__container {
    @include container;
  }

  &__inner {
    position: relative;

    display: flex;
    justify-content: center;

    @include media(max-width, m) {
      justify-content: flex-start;
    }
  }

  &__content {
    width: grid-element(11);

    text-align: left;

    /* stylelint-disable selector-nested-pattern */
    p {
      display: inline;
      margin: 0;

      color: inherit;
      font-weight: inherit;
    }

    a {
      color: inherit;

      text-decoration: underline;

      &:hover {
        color: inherit;

        text-decoration: underline;
      }
    }

    mark {
      font-weight: font-weight(bold);
    }
    /* stylelint-enable */

    @include media(min-width, m) {
      width: grid-element(11);

      text-align: center;
    }
  }

  &__close {
    position: absolute;
    top: 50%;
    right: 0;

    color: $grey-pale;

    transform: translateY(-50%);

    cursor: pointer;
  }

  &__close-icon {
    fill: currentColor;
  }

  &--notification {
    color: $white;

    background: $blue;
  }

  &--sale {
    @include font-style(h5, $color: $white);

    padding: 0;

    /* stylelint-disable-next-line selector-nested-pattern */
    a {
      font-weight: font-weight(bold);
    }
  }
}
</style>
